import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	connectedProjectsLoadFailureTitle: {
		id: 'shared-software-dates.common.connected-projects-load-failure-title',
		defaultMessage: "We couldn't load connected projects",
		description: 'Heading for connected projects loading failure flag',
	},
	projectConnectionFailureTitle: {
		id: 'shared-software-dates.common.project-connection-failure-title',
		defaultMessage: "We couldn't connect to your project",
		description: 'Heading for projects connection failure flag',
	},
	projectConnectionUnexpectedFailureDescription: {
		id: 'shared-software-dates.common.project-connection-unexpected-failure-description',
		defaultMessage:
			"Make sure you're connected to the right network or contact your workspace admin for support.",
		description: 'Explanation of unexpected error of changing connection between projects',
	},
	connectPermissionsFailFlagTitle: {
		id: 'shared-software-dates.common.connect-permissions-fail-flag-title',
		defaultMessage: "You don't have permission to connect this project",
		description:
			'Text for the permissions warning underneath the project select when the user is not a project admin',
	},
	connectPermissionsFailFlagDescription: {
		id: 'shared-software-dates.common.connect-permissions-fail-flag-description',
		defaultMessage:
			'Contact your Jira admin for permission to add release dates of a software project.',
		description:
			'Text for the permissions warning underneath the project select when the user is not a project admin',
	},
	disconnectPermissionsFailFlagTitle: {
		id: 'shared-software-dates.common.disconnect-permissions-fail-flag-title',
		defaultMessage: "You don't have permission to disconnect this project",
		description:
			'Text for the permissions warning underneath the project select when the user is not a project admin',
	},
	disconnectPermissionsFailFlagDescription: {
		id: 'shared-software-dates.common.disconnect-permissions-fail-flag-description',
		defaultMessage:
			'Contact your Jira admin for permission to remove release dates from a software project.',
		description:
			'Text for the permissions warning underneath the project select when the user is not a project admin',
	},
	projectConnectionNotFoundTitle: {
		id: 'shared-software-dates.common.project-connection-not-found-title',
		defaultMessage: "We couldn't find the connected software project",
		description: 'Heading for projects connection failure flag',
	},
	projectConnectionNotFoundDescription: {
		id: 'shared-software-dates.common.project-connection-not-found-description',
		defaultMessage:
			'The connected software project may have been deleted. Refresh the page, then try again.',
		description: 'Text for the projects connection failure flag',
	},
	projectsConnectionSuccessFlagHeading: {
		id: 'shared-software-dates.common.projects-connection-success-flag-heading',
		defaultMessage: "You're showing software project release dates for {projectName}",
		description: 'Heading for projects connection success flag',
	},
	projectsConnectionSuccessFlagText: {
		id: 'shared-software-dates.common.projects-connection-success-flag-text',
		defaultMessage: 'All release dates from this project will appear in your calendar.',
		description: 'Text for the projects connection success flag',
	},
	projectsConnectionFailureFlagHeading: {
		id: 'shared-software-dates.common.projects-connection-failure-flag-heading',
		defaultMessage: 'Trouble showing software project release dates',
		description: 'Heading for projects connection failure flag',
	},
	projectsConnectionFailureFlagText: {
		id: 'shared-software-dates.common.projects-connection-failure-flag-text',
		defaultMessage:
			"It looks like we're having some trouble showing and hiding software project release dates. Wait a few moments, then try again.",
		description: 'Text for the projects connection failure flag',
	},
	projectsDisconnectionSuccessFlagHeading: {
		id: 'shared-software-dates.common.projects-disconnection-success-flag-heading',
		defaultMessage: "You've hidden software project release dates for {projectName}",
		description: 'Heading for projects disconnection success flag',
	},
	projectsDisconnectionSuccessFlagText: {
		id: 'shared-software-dates.common.projects-disconnection-success-flag-text',
		defaultMessage: 'Release dates from this project will no longer show in your calendar.',
		description: 'Text for the projects disconnection success flag',
	},
	showSoftwareReleasesToggleText: {
		id: 'shared-software-dates.common.show-software-releases-toggle-text',
		defaultMessage: 'Show software releases',
		description: 'Text for the Show software releases toggle',
	},
});
